import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import styles from './slide-in.module.css';

export class SlideIn extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        direction: PropTypes.oneOf(['left', 'right', 'up', 'down']),
    };

    static defaultProps = {
        direction: 'left',
    };

    render() {
        const {direction, ...other} = this.props;

        // Add a custom className to every child
        const children = React.Children.map(this.props.children, (child) => {
            const childClass = classnames(
                child.props.className,
                styles['transition-slide-in-child']
            );

            return React.cloneElement(child, {className: childClass});
        });

        return (
            <ReactCSSTransitionGroup
                {...other}
                transitionName={{
                    enter: styles.enter,
                    enterActive: styles['enter-active'],
                    leave: styles.leave,
                    leaveActive: styles['leave-active'],
                }}
                component='div'
                transitionAppearTimeout={250}
                transitionEnterTimeout={250}
                transitionLeaveTimeout={250}
                className={styles[`transition-slide-in--${direction}`]}
            >
                {children}
            </ReactCSSTransitionGroup>
        );
    }
}
